import BookingsHtml from './transaction-center.bookings.html';

export const TransactionCenterBookingsComponent : ng.IComponentOptions = {
  bindings: {
    bookings: '='
  },
  controller  : 'TransactionCenterBookingsCtrl',
  controllerAs: '$ctrl',
  templateUrl : BookingsHtml,
};